import React from 'react';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative h-screen w-full overflow-hidden" data-id="element-115">
      {/* Background Video */}
      <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover" src="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/GLE%20Website%20Video.mp4" data-id="element-116" />
      {/* Overlay Gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" data-id="element-117" />

      {/* Content */}
      <div className="absolute bottom-[15%] left-0 px-8 md:px-12 lg:px-20 max-w-4xl z-10" data-id="element-118">
        <h1 className="font-optima font-bold text-[40px] md:text-[56px] lg:text-[80px] text-white leading-[1.1] mb-4 animate-fade-in-up" data-id="element-119">
          A Cool-Climate Challenger from the Pyrenees
        </h1>
        <h2 className="font-optima font-medium text-[20px] md:text-[24px] lg:text-[28px] text-white/90 mb-6 animate-fade-in-up stagger-1" data-id="element-120">
          Glenlofty Estate, Victoria
        </h2>
        <p className="font-optima text-[17px] lg:text-[20px] text-white/85 max-w-xl leading-relaxed mb-8 animate-fade-in-up stagger-2" data-id="element-121">
          Discover the soul of the Pyrenees in every bottle. From our rugged,
          ancient soils, we craft wines of exceptional elegance, intensity, and
          character.
        </p>
        <button className="border-2 border-white text-white bg-transparent px-8 py-3 rounded-[4px] uppercase text-[16px] font-semibold tracking-wide-btn hover:bg-gold hover:border-gold hover:text-white transition-all animate-fade-in-up stagger-3" data-id="element-122">
          Discover Our Story
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-scroll-indicator text-white" data-id="element-123">
        <ChevronDown size={32} data-id="element-124" />
      </div>
    </section>;
}